module.exports = __webpack_public_path__ + "media/Social/Whatsapp-9c3f05cb.svg";